import { experimentCheck } from 'experiments/experiment';

/**
 * Reduces all of the current experiments into a single string
 *
 * @param experiments The list of active experiments
 */
export const mapExperimentsToString = (experiments: unknown): string =>
  (experimentCheck(experiments) &&
    Object.values(experiments)
      .reduce((acc, [key, flag]) => `${acc}!${key}.${flag}`, '')
      .replace(/^!/, '')) ||
  '';

export const mapUrlToCategories = (url: string) => {
  const urlArray = url.split('/').filter(Boolean);
  // Remove the two last items, product name and product id, to get the categories
  return urlArray.slice(0, -2);
};
